import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import style from '../css/Login.module.css';
import image from '../images/login.png';
import { FaEye, FaEyeSlash } from 'react-icons/fa';

const AdminLogin = () => {
	const [agentId, setAgentId] = useState('HomeTech');
	const [password, setPassword] = useState('');
	const [showPassword, setShowPassword] = useState(false);
	const [error, setError] = useState('');
	const navigate = useNavigate();

	// Predefined admin credentials
	const ADMIN_ID = 'HomeTech';
	const ADMIN_PASSWORD = '9686';

	const handleLogin = () => {
		if (!agentId || !password) {
			setError('Please fill in all fields');
			return;
		}

		if (agentId === ADMIN_ID && password === ADMIN_PASSWORD) {
			setError('');
			setError('Login Successful');
			navigate('/chat-list');
		} else {
			setError('Invalid Agent ID or Password');
		}
	};

	return (
		<div className={style.container}>
			<div className={style.card}>
				<h2 className={style.title}>Admin Login</h2>
				<img src={image} alt="Login" className={style.image} />

				<div className={style.textCont}>
					<div className={style.passwordDiv}>
						<input
							type="text"
							value={agentId}
							onChange={(e) => setAgentId(e.target.value)}
							className={style.input}
							placeholder="Agent ID"
						/>
					</div>

					<div className={style.passwordDiv}>
						<input
							type={showPassword ? 'text' : 'password'}
							value={password}
							onChange={(e) => setPassword(e.target.value)}
							className={style.passinput}
							placeholder="Password"
							keyboardType="numeric"
						/>
						<p onClick={() => setShowPassword(!showPassword)}>
							{showPassword ? (
								<FaEyeSlash size={20} color="black" />
							) : (
								<FaEye size={20} color="black" />
							)}
						</p>
					</div>

					<div onClick={handleLogin} className={style.button}>
						Login
					</div>

					<p>{error}</p>

					<Link className={style.btn} to={'/'}>
						Agent Login
					</Link>
				</div>
			</div>
		</div>
	);
};

export default AdminLogin;
